var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgCompleted(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: `url(#${_id})`,
    stroke: "#17C868",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43 20.79V3.21M3.43 18.479l2.464-.758a7.509 7.509 0 016.143.781 7.511 7.511 0 006 .825l2.333-.666a.88.88 0 00.638-.845V5.466a.88.88 0 00-1.12-.845l-1.851.529a7.512 7.512 0 01-6-.825 7.508 7.508 0 00-6.143-.781L3.43 4.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.734 9.07l-3.515 4.688-2.344-2.344"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.219 2)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgCompleted;